var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.toggle()}}},[_vm._t("toggler",function(){return [_c('button',[_vm._v("Toggle")])]}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }